import React from 'react';
import { createRoot } from 'react-dom/client';
import { Bubble, BubbleType } from './Bubble';

const BUBBLES_STORAGE_KEY = 'jb-bubbles-visibility';

const getVisibilityFromLocalStorage = () => {
  const hiddenBubbles = localStorage.getItem(BUBBLES_STORAGE_KEY);
  if (!hiddenBubbles) return [];
  return JSON.parse(hiddenBubbles);
};

const setVisibilityOnLocalStorage = (hiddenBubbles: Array<string>) => {
  localStorage.setItem(BUBBLES_STORAGE_KEY, JSON.stringify(hiddenBubbles));
};

const getGlobalBubbles = () => {
  return window.Jbhifi?.newBubbles || [];
};

const getQuerySelector = (text: string) => {
  if (text.charAt(0) === '.' || text.charAt(0) === '#') {
    return text;
  } else if (text.includes('[') && text.includes(']')) {
    return text;
  } else {
    return `.${text}`;
  }
};

export const drawBubbles = () => {
  const bubbles = getGlobalBubbles();
  const hiddenBubbles = getVisibilityFromLocalStorage();

  const handleBubbleClick = (elementClass: string) => {
    const newBubbles = hiddenBubbles ? [...hiddenBubbles, elementClass] : [elementClass];
    setVisibilityOnLocalStorage(newBubbles);
  };

  const mountBubble = (Bubble: JSX.Element, elementClass: string, tries: number = 0) => {
    if (tries > 5) {
      console.error("Couldn't find the element to mount a NEW tag on page within 5 seconds!");
      return;
    }
    const container = document.querySelector(getQuerySelector(elementClass)) as HTMLElement;
    if (container && container?.tagName !== 'DIV') {
      console.error('Tried to mount a NEW tag to a non-div element!');
      return;
    }
    if (!container) {
      setTimeout(() => {
        mountBubble(Bubble, elementClass, tries + 1);
      }, 1000);
      return;
    }
    container.style.position = 'relative';
    const portalElement = document.createElement('div');
    container.appendChild(portalElement);
    const root = createRoot(portalElement);
    root.render(Bubble);
  };

  bubbles.map((bubble: BubbleType) => {
    if (!bubble?.elementClass || !hiddenBubbles) return;
    if (hiddenBubbles.includes(bubble.elementClass)) return;
    try {
      const componentToAppend = (
        <Bubble
          position={bubble.position}
          offset={bubble.offset}
          variant={bubble.variant}
          text={bubble.text}
          mobile={bubble.mobile}
          isArrowHidden={bubble.isArrowHidden}
          distance={bubble.distance}
          onClick={() => handleBubbleClick(bubble.elementClass)}
        />
      );
      mountBubble(componentToAppend, bubble.elementClass);
    } catch (error) {
      console.error('A New Tag used an invalid element selector!', error);
    }
  });
};
